// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"SellerDashboard_dashboardContainer__vZ1xY"};